<template>
  <div class="report-fs" style="direction: ltr">
    <!-- <div style="margin-top: 178px;" v-if="pathLogo == m"></div>
    <div style="margin-top: 35px;" v-if="pathLogo != m"></div>
    <div class="mlogo t-alignlogo">
      <img class="wlogo" :src="pathLogo" />
    </div> -->
    <h3 class="text-center fs-head-co">{{ name }}</h3>
    <h3 class="text-center fs-head-co">{{ desc }}</h3>
    <!-- <h3 class="text-center fs-head">تقرير الحضور والإنصراف اليومي <span>ليوم {{ dateF != null && dateF != '' ?
      day_n(dateF) : '' }} </span></h3> -->
    <!-- <h3 class="text-center fs-head"> {{ DepartmentId == "" ? "" : data[0].departmentName }}</h3> -->
    <h4 class="text-left" style="margin-left: 50px; direction: ltr">
      التاريخ : {{ convertToUi(new Date()) }}
    </h4>

    <md-card-content dir="rtl" class="redirect-dir">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header
              style="margin-bottom: 30px"
              class="md-card-header-text md-card-header-green"
            >
              <div class="card-text">
                <h4 class="title">
                  تقرير الحضور والإنصراف اليومي
                  <span
                    >ليوم {{ dateF != null && dateF != "" ? day_n(dateF) : "" }}
                  </span>
                </h4>
              </div>
            </md-card-header>

            <div
              style="margin-top: 10px; margin-bottom: 35px"
              class="marginTop"
            >
              <md-card-content>
                <md-table
                  class="paginated-table table-striped table-hover mt-25"
                >
                  <md-table-row>
                    <md-table-cell class="border-staffLists">ر.م</md-table-cell>

                    <md-table-cell class="border-staffLists"
                      >رقم الموظف</md-table-cell
                    >

                    <md-table-cell class="border-staffLists"
                      >الاسم</md-table-cell
                    >
                    <md-table-cell class="border-staffLists"
                      >مكان العمل</md-table-cell
                    >

                    <md-table-cell class="border-staffLists"
                      >وقت الحضور</md-table-cell
                    >

                    <md-table-cell class="border-staffLists"
                      >وقت الإنصراف</md-table-cell
                    >

                    <!-- <md-table-cell class="border-staffLists">الوضع الحالي</md-table-cell> -->

                    <md-table-cell class="border-staffLists"
                      >ملاحظة</md-table-cell
                    >
                  </md-table-row>
                  <md-table-row v-for="(item, i) in data" :key="i">
                    <md-table-cell class="border-staffLists" md-label="الصنف">{{
                      i + 1
                    }}</md-table-cell>

                    <md-table-cell
                      style="text-align: center"
                      class="border-staffLists"
                      md-label="الصنف"
                      >{{ item.jobNumber }}</md-table-cell
                    >

                    <md-table-cell class="border-staffLists" md-label="الصنف">{{
                      item.employeeName
                    }}</md-table-cell>

                    <md-table-cell md-label="مكان العمل">
                      {{ item.workPlaceName }}
                    </md-table-cell>

                    <md-table-cell class="border-staffLists" md-label="الصنف">{{
                      item.attendanceTime
                    }}</md-table-cell>

                    <md-table-cell class="border-staffLists" md-label="الصنف">{{
                      item.leaveTime
                    }}</md-table-cell>
                    <md-table-cell class="border-staffLists" md-label="الصنف">{{
                      item.daySituation
                    }}</md-table-cell>

                    <!-- <md-table-cell class="border-staffLists" md-label="الصنف">{{
                   
                    }}</md-table-cell> -->

                    <!-- <md-table-cell class="border-staffLists" md-label="الصنف">
                      {{
                        item.dayType == 3
                          ? "إجازة"
                          : item.currentSituation == 4
                          ? "متفرغ"
                          : item.currentSituation == 5
                          ? "مكلف"
                          : item.currentSituation == 6
                          ? "تدريب"
                          : excuseType(item.excuseType)
                      }}
                    </md-table-cell> -->
                  </md-table-row>
                </md-table>
              </md-card-content>
            </div>
          </md-card>
        </div>
      </div>
    </md-card-content>
  </div>
</template>

<script>
//  import { count } from "console";
import env from "../../../env";

export default {
  mounted() {},
  props: [
    "name",
    "desc",
    "data",
    "pathLogo",
    "countE",
    "DepartmentId",
    "dateF",
  ],
  data() {
    return {
      stName: "",
      currentSort: "",
      currentSortOrder: "asc",
      m: env.mTop(),
    };
  },
  methods: {
    excuseType(newValue) {
      switch (newValue) {
        case 1:
          this.stName = "عذر تأخير";
          break;

        case 2:
          this.stName = "عذر  خروج مبكر";
          break;

        case 3:
          this.stName = "غياب بعذر";
          break;

        case 4:
          this.stName = "عذر خروج بلا بصمة";
          break;

        default:
          this.stName = "";
          break;
      }
      return this.stName;
    },

    day_n(event) {
      let d = new Date(event);
      let fullDay =
        d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear();

      return fullDay;
    },

    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    convertToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return " - ";
        }
        return (
          d.getDate() + " - " + (d.getMonth() + 1) + " - " + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
  },
};
</script>
